import { render, staticRenderFns } from "./PatchCord.vue?vue&type=template&id=bba8351c"
import script from "./PatchCord.vue?vue&type=script&lang=js"
export * from "./PatchCord.vue?vue&type=script&lang=js"
import style0 from "./PatchCord.vue?vue&type=style&index=0&id=bba8351c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports